// Must stay the first CSS import so Bootstrap's rules land before any app or
// component CSS in the extracted bundle and remain overridable.
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { createRoot, } from 'react-dom/client';
import { Provider, } from 'react-redux';
import { HashRouter, Routes, Route, } from 'react-router-dom';
import '@babel/polyfill';
import store from './store';
import NotFoundPage from './components/view/NotFoundPage/NotFoundPage';
import Login from './containers/LoginContainer';
import App from './containers/AppContainer';
import LockScreenContainer from './containers/LockScreenContainer';
import SessionGate from './components/SessionGate';
import './index.css';

const root = createRoot(document.getElementById('main'));
root.render(
  <Provider store={store}>
    <SessionGate>
      {/* The lock screen sits beside the routes so it can tell which page it would
          be covering — see LockScreenContainer. */}
      <HashRouter>
        <>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/dashboard" element={<App />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <LockScreenContainer />
        </>
      </HashRouter>
    </SessionGate>
  </Provider>
);

if (module.hot) {
  module.hot.accept();
}
